import React, { useState } from 'react';
import { Leaf } from 'lucide-react';
import { Modal } from './ui/Modal';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="bg-[#2D2A26] text-stone-400 py-12 px-6 text-center" data-id="element-12">
        <div className="flex items-center justify-center gap-2 mb-6" data-id="element-13">
          <Leaf className="w-6 h-6 text-[#C4A35A]" data-id="element-14" />
          <span className="font-serif text-xl text-[#FAF7F2]" data-id="element-15">
            Vida Sin Tabú
          </span>
        </div>
        <p className="text-sm mb-4" data-id="element-16">
          &copy; {new Date().getFullYear()} Vida Sin Tabú. Todos los derechos
          reservados.
        </p>
        <div className="flex justify-center gap-6 text-xs" data-id="element-17">
          <button onClick={() => setActiveModal('terms')} className="hover:text-[#C4A35A] transition-colors" data-id="element-18">
            Términos y Condiciones
          </button>
          <button onClick={() => setActiveModal('privacy')} className="hover:text-[#C4A35A] transition-colors" data-id="element-19">
            Política de Privacidad
          </button>
        </div>
      </footer>

      {/* Terms Modal */}
      <Modal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos y Condiciones" data-id="element-20">
        <div className="space-y-4 text-gray-700" data-id="element-21">
          <p className="text-sm text-gray-500" data-id="element-22">
            Última actualización: Febrero 2026
          </p>

          <h3 className="font-serif text-lg text-[#2D2A26] mt-6" data-id="element-23">
            1. Aceptación de los Términos
          </h3>
          <p data-id="element-24">
            Al acceder y utilizar este sitio web y adquirir nuestros productos
            digitales, aceptas estar sujeto a estos términos y condiciones de
            uso. Si no estás de acuerdo con alguna parte de estos términos, te
            pedimos que no utilices nuestros servicios.
          </p>

          <h3 className="font-serif text-lg text-[#2D2A26] mt-6" data-id="element-25">
            2. Productos Digitales
          </h3>
          <p data-id="element-26">
            "Intimidad Sin Presión" es un producto digital en formato PDF. Una
            vez completada la compra, recibirás acceso inmediato al contenido.
            Debido a la naturaleza digital del producto, no se aceptan
            devoluciones una vez descargado el material.
          </p>

          <h3 className="font-serif text-lg text-[#2D2A26] mt-6" data-id="element-27">
            3. Uso Personal
          </h3>
          <p data-id="element-28">
            El contenido adquirido es para uso personal y de pareja únicamente.
            Queda estrictamente prohibida la reproducción, distribución,
            modificación o uso comercial del material sin autorización expresa
            por escrito.
          </p>

          <h3 className="font-serif text-lg text-[#2D2A26] mt-6" data-id="element-29">
            4. Propiedad Intelectual
          </h3>
          <p data-id="element-30">
            Todo el contenido, incluyendo textos, gráficos, logos y metodologías
            presentadas, son propiedad exclusiva de Vida Sin Tabú y están
            protegidos por las leyes de propiedad intelectual aplicables.
          </p>

          <h3 className="font-serif text-lg text-[#2D2A26] mt-6" data-id="element-31">
            5. Limitación de Responsabilidad
          </h3>
          <p data-id="element-32">
            El contenido de este producto es informativo y educativo. No
            sustituye la orientación profesional de terapeutas, psicólogos o
            médicos. Vida Sin Tabú no se hace responsable por el uso que se le
            dé al material ni por los resultados individuales obtenidos.
          </p>

          <h3 className="font-serif text-lg text-[#2D2A26] mt-6" data-id="element-33">
            6. Modificaciones
          </h3>
          <p data-id="element-34">
            Nos reservamos el derecho de modificar estos términos en cualquier
            momento. Los cambios entrarán en vigor inmediatamente después de su
            publicación en este sitio web.
          </p>
        </div>
      </Modal>

      {/* Privacy Modal */}
      <Modal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-35">
        <div className="space-y-4 text-gray-700" data-id="element-36">
          <p className="text-sm text-gray-500" data-id="element-37">
            Última actualización: Febrero 2026
          </p>

          <h3 className="font-serif text-lg text-[#2D2A26] mt-6" data-id="element-38">
            1. Información que Recopilamos
          </h3>
          <p data-id="element-39">
            Recopilamos únicamente la información necesaria para procesar tu
            compra:
          </p>
          <ul className="list-disc pl-5 space-y-1" data-id="element-40">
            <li data-id="element-41">Dirección de correo electrónico (para enviar el producto)</li>
            <li data-id="element-42">
              Información de pago (procesada de forma segura por terceros)
            </li>
          </ul>

          <h3 className="font-serif text-lg text-[#2D2A26] mt-6" data-id="element-43">
            2. Uso de la Información
          </h3>
          <p data-id="element-44">Tu información personal se utiliza exclusivamente para:</p>
          <ul className="list-disc pl-5 space-y-1" data-id="element-45">
            <li data-id="element-46">Procesar y entregar tu compra</li>
            <li data-id="element-47">Enviarte actualizaciones importantes sobre tu producto</li>
            <li data-id="element-48">Responder a consultas de soporte</li>
          </ul>

          <h3 className="font-serif text-lg text-[#2D2A26] mt-6" data-id="element-49">
            3. Protección de Datos
          </h3>
          <p data-id="element-50">
            Implementamos medidas de seguridad técnicas y organizativas para
            proteger tu información personal contra acceso no autorizado,
            alteración, divulgación o destrucción. Tu privacidad es nuestra
            prioridad.
          </p>

          <h3 className="font-serif text-lg text-[#2D2A26] mt-6" data-id="element-51">
            4. No Compartimos tu Información
          </h3>
          <p data-id="element-52">
            Nunca vendemos, intercambiamos ni transferimos tu información
            personal a terceros. La única excepción son los proveedores de
            servicios de pago que nos ayudan a procesar transacciones de forma
            segura.
          </p>

          <h3 className="font-serif text-lg text-[#2D2A26] mt-6" data-id="element-53">5. Cookies</h3>
          <p data-id="element-54">
            Utilizamos cookies esenciales para el funcionamiento del sitio. No
            utilizamos cookies de seguimiento ni compartimos datos con
            plataformas publicitarias.
          </p>

          <h3 className="font-serif text-lg text-[#2D2A26] mt-6" data-id="element-55">
            6. Tus Derechos
          </h3>
          <p data-id="element-56">
            Tienes derecho a acceder, rectificar o eliminar tus datos personales
            en cualquier momento. También puedes solicitar una copia de la
            información que tenemos sobre ti.
          </p>

          <h3 className="font-serif text-lg text-[#2D2A26] mt-6" data-id="element-57">
            7. Confidencialidad del Contenido
          </h3>
          <p data-id="element-58">
            Entendemos la naturaleza sensible del tema. Tu compra es
            completamente confidencial y no aparecerá con nombres explícitos en
            estados de cuenta.
          </p>
        </div>
      </Modal>
    </>;
}